import type React from 'react';

import FileUploadProgressModal from '@/components/organism/FileUploadModal/FileUploadProgressModal';
import FileUploadDialogV2 from '@/components/organism/FileUploadModal/FileUploadDialogV2';
import { useFileUploadModal } from '@/hooks/fileUpload/useFileUploadModal';

function FileUploadModalContainer(): React.JSX.Element | null {
  const { state, handlers } = useFileUploadModal();

  if (!state.isOpen) return null;

  if (state.step === 'progress') {
    return (
      <FileUploadProgressModal
        isOpen={state.isOpen}
        currentUpload={state.currentUpload}
        currentUploadFileName={state.currentUploadFileName}
        currentUploadError={state.currentUploadError}
        encryptionSteps={state.encryptionSteps}
        uploadedFileCount={state.uploadedFileCount}
        totalFileCount={state.files.length}
        canRetryCurrentUpload={state.canRetryCurrentUpload}
        isUploading={state.isUploading}
        onClose={handlers.handleClose}
        onDone={handlers.handleDone}
        onRetryCurrentUpload={handlers.handleRetryCurrentUpload}
      />
    );
  }

  return (
    <FileUploadDialogV2
      isOpen={state.isOpen}
      step={state.step}
      files={state.files}
      encryptionSteps={state.encryptionSteps}
      uploadedFileCount={state.uploadedFileCount}
      isUploadDisabled={state.isUploadDisabled}
      encryptionInfo={state.encryptionInfo}
      onClose={handlers.handleClose}
      onFilesAdded={handlers.handleFilesAdded}
      onFileRemoved={handlers.handleFileRemoved}
      onUpload={handlers.handleUpload}
      onDone={handlers.handleDone}
    />
  );
}

export default FileUploadModalContainer;
